export const buyerNames = [
  'Camila S.',
  'Martín G.',
  'Sofía R.',
  'Lucas P.',
  'Julieta M.',
  'Nicolás F.',
  'Agustina L.',
  'Facundo D.',
  'Valentina C.',
  'Matías B.',
  'Rocío A.',
  'Tomás V.',
  'Micaela T.',
  'Joaquín H.',
  'Brenda N.',
  'Ezequiel O.',
]

export const buyerCities = [
  'CABA, Buenos Aires',
  'La Plata, Buenos Aires',
  'Mar del Plata, Buenos Aires',
  'Bahía Blanca, Buenos Aires',
  'Córdoba Capital, Córdoba',
  'Río Cuarto, Córdoba',
  'Rosario, Santa Fe',
  'Santa Fe Capital, Santa Fe',
  'Mendoza Capital, Mendoza',
  'San Miguel de Tucumán, Tucumán',
  'Salta Capital, Salta',
  'Neuquén Capital, Neuquén',
  'Posadas, Misiones',
  'Corrientes Capital, Corrientes',
  'San Juan Capital, San Juan',
  'Resistencia, Chaco',
]

/** Las dos ofertas disponibles en la landing (editá los nombres si cambian). */
export const purchasedOffers = [
  'MegaPack Hábitos + 5 bonos',
  'MegaPack Completo + 5 bonos',
]

export const purchaseTimeAgo = [
  'hace 2 minutos',
  'hace 4 minutos',
  'hace 6 minutos',
  'hace 9 minutos',
  'hace 12 minutos',
  'hace 18 minutos',
]
